module.exports = __webpack_public_path__ + "static/white-logo-f7ea3df382093e63bf7d3c0a4d611ddc.jpg";